// opervex-frontend/src/routes/privateRoute.js

import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const PrivateRoute = ({ children, requiredRoles, admin, tenantId }) => {
  const { user, roles, loadingGlobal } = useAuth();

  if (loadingGlobal) return <div>Carregando...</div>;

  if (!user) return <Navigate to={`/${tenantId}/Login`} />;

  if (requiredRoles) {
    const hasPermission = roles.some((x) => x.command === requiredRoles);

    if (!hasPermission) return <Navigate to={`/${tenantId}`} />;
  }

  if (admin && !user.administrator) return <Navigate to={`/${tenantId}`} />;

  return children;
};

export default PrivateRoute;
